"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalTxsProcessor = void 0;
var SimpleProcessor_1 = require("../common/SimpleProcessor");
var InternalTxDocumentBuilder_1 = require("./InternalTxDocumentBuilder");
var InternalTxsProcessor = /** @class */ (function () {
    function InternalTxsProcessor(collectionNameBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
        this.simpleProcessor = new SimpleProcessor_1.SimpleProcessor(this.collectionNameBuilder, InternalTxDocumentBuilder_1.InternalTxDocumentBuilder.build);
    }
    InternalTxsProcessor.prototype.process = function (batch) {
        return this.simpleProcessor.process(batch.txsInternal, batch);
    };
    return InternalTxsProcessor;
}());
exports.InternalTxsProcessor = InternalTxsProcessor;
//# sourceMappingURL=InternalTxsProcessor.js.map